// Alt SEO des images produit : [type de produit] + [qualificatif] + [reste du titre].
// Qualificatif = couleur (catégories couleur, variations) sinon « personnalisé(e) ».
// Ex. « CABAS EMY » → « Cabas personnalisé emy » ; sur /noir « POCHETTE AUDREY M » → « Pochette noire audrey m ».

// Du plus spécifique au plus générique (le premier préfixe qui matche gagne).
const PRODUCT_TYPES = [
  ["mini tote bag", "m"],
  ["tote bag", "m"],
  ["totebag", "m"],
  ["sac à dos", "m"],
  ["sac de sport", "m"],
  ["sac", "m"],
  ["sacoche", "f"],
  ["cabas", "m"],
  ["pochette", "f"],
  ["trousse", "f"],
  ["sweat-shirt", "m"],
  ["sweat", "m"],
  ["tee-shirt", "m"],
  ["t-shirt", "m"],
  ["tshirt", "m"],
  ["hoodies", "m"],
  ["polo", "m"],
  ["casquette", "f"],
  ["doudoune", "f"],
  ["veste", "f"],
  ["tablier", "m"],
];

const FEMININE_COLORS = { noir: "noire", blanc: "blanche", bleu: "bleue", vert: "verte" };

const agree = (word, gender) => {
  if (gender !== "f") return word;
  if (word === "personnalisé") return "personnalisée";
  return FEMININE_COLORS[word] || word;
};

const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const productAlt = (title, color) => {
  const t = (title || "").normalize("NFC").toLowerCase().replace(/\s+/g, " ").trim();
  if (!t) return "";
  const type = PRODUCT_TYPES.find(([word]) => t === word || t.startsWith(`${word} `));
  if (!type) return capitalize(t);
  const [word, gender] = type;
  const qualifier = agree(color ? color.toLowerCase().trim() : "personnalisé", gender);
  const rest = t.slice(word.length).trim();
  return capitalize([word, qualifier, rest].filter(Boolean).join(" "));
};
